export default "__VITE_ASSET__6418580a__"